import { render, staticRenderFns } from "./EditFarm.vue?vue&type=template&id=68ac7c2e&"
import script from "./EditFarm.vue?vue&type=script&lang=js&"
export * from "./EditFarm.vue?vue&type=script&lang=js&"
import style0 from "./EditFarm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports